/* eslint-disable */ // @ts-nocheck
export var headers = {
  "Content-Type": "application/json"
};
export var method = "GET";
export var credentials = "same-origin";
export function queryStringify(params, inBody) {
  var items = [];
  function itemStringify(obj, prefix) {
    var type = Object.prototype.toString.call(obj);
    if (type === "[object Array]") {
      obj.forEach(function (item, key) {
        itemStringify(item, prefix + "[" + key + "]");
      });
    } else if (type === "[object Object]") {
      for (var key in obj) {
        itemStringify(obj[key], prefix + "[" + key + "]");
      }
    } else if (type === "[object Date]") {
      items.push(prefix + "=" + obj.toISOString());
    } else if (type === "[object Null]") {
      items.push(prefix + "=");
    } else if (type !== "[object Undefined]") {
      items.push(prefix + "=" + encodeURIComponent(obj));
    }
  }
  for (var k in params) {
    itemStringify(params[k], k);
  }
  var str = items.join("&");
  return str && !inBody ? "?" + str : str;
}